import { Node, Schema } from "prosemirror-model";
import { CSSResultGroup } from "lit";
import { EditorView } from "prosemirror-view";
import { Plugin } from "prosemirror-state";
import { ParseSpecMap, MarkdownSerializerConfig } from "./types";
import { MenuFunction } from "./menu";
import MarkdownIt from "markdown-it";

export abstract class BaseExtension {
    protected view: EditorView | undefined;

    /**
     * Additional styles (CSS).
     */
    css: string[] | CSSResultGroup[] = [];

    setView(view: EditorView) {
        this.view = view;
    }

    /**
     * Override this method to modify the editor's menu
     */
    menu?(currentMenu: MenuFunction): MenuFunction {
        return currentMenu;
    }

    /**
     * Override this method to add plugins to the editor
     */
    plugins?(_schema: Schema): Plugin[] {
        return [];
    }

    /**
     * Override this method to modify the document after parsing
     */
    async upgradeParsedDocument?(doc: Node, _schema: Schema): Promise<Node> {
        return doc;
    }

    /**
     * Override this method to modify the editor's schema
     */
    modifySchema?(schema: Schema): Schema {
        return schema;
    }

    /**
     * Override this method to modify how markdown is parsed
     */
    modifyParser?(parseSpec: ParseSpecMap, _schema: Schema): ParseSpecMap {
        return parseSpec;
    }

    /**
     * Override this method to modify how content is serialized to markdown
     */
    modifySerializer?(
        config: MarkdownSerializerConfig
    ): MarkdownSerializerConfig {
        return config;
    }

    /**
     * Override this method to modify the markdown-it instance
     */
    modifyMarkdownIt?(markdownIt: MarkdownIt): MarkdownIt {
        return markdownIt;
    }
}
